import { Injectable } from '@angular/core';
import { StorageService } from '@shared';

@Injectable({ providedIn: 'root' })
export class SyncIntervalProvider {
	private SYNC_INTERVAL = 'SyncIntervalProvider_SYNC_INTERVAL_VALUE';
	private NO_INTERNET_ERROR_MESSAGE = 'SyncIntervalProvider_NO_INTERNET_ERROR_MESSAGE';

	public constructor(private storageService: StorageService) {}

	public async setIntervalInMinutes(intervalInMinutes: number): Promise<void> {
		if (intervalInMinutes === 0 || intervalInMinutes >= 30) {
			await this.storageService.set(this.SYNC_INTERVAL, intervalInMinutes);
		}
	}

	public async getIntervalInMinutes(): Promise<number> {
		const syncInterval = await this.storageService.get(this.SYNC_INTERVAL);
		return Number(syncInterval);
	}

	public async setNoInternetErrorMessage(displayNoInternetErrorMessage: boolean): Promise<void> {
		await this.storageService.set(this.NO_INTERNET_ERROR_MESSAGE, displayNoInternetErrorMessage);
	}

	public async getNoInternetErrorMessage(): Promise<boolean> {
		const getNoInternetErrorMessage = await this.storageService.get(this.NO_INTERNET_ERROR_MESSAGE);
		return !!getNoInternetErrorMessage;
	}

	public async isSyncOn(): Promise<boolean> {
		const syncInterval: number = await this.storageService.get(this.SYNC_INTERVAL);
		return syncInterval !== null && syncInterval !== undefined && syncInterval >= 30;
	}
}
